import {
  TEMPLATE_FETCH_TEMPLATE_BEGIN,
  TEMPLATE_FETCH_TEMPLATE_SUCCESS,
  TEMPLATE_FETCH_TEMPLATE_FAILURE,
  TEMPLATE_FETCH_TEMPLATE_DISMISS_ERROR,
} from './constants';

import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function fetchTemplate(args = {}) {
  return (dispatch) => {
    dispatch({
      type: TEMPLATE_FETCH_TEMPLATE_BEGIN,
    });
    const { projectId, version, templateId } = args;
    let config = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/templates/${templateId}/content`,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: TEMPLATE_FETCH_TEMPLATE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: TEMPLATE_FETCH_TEMPLATE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchTemplateError() {
  return {
    type: TEMPLATE_FETCH_TEMPLATE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case TEMPLATE_FETCH_TEMPLATE_BEGIN:
      return {
        ...state,
        fetchTemplatePending: true,
        fetchTemplateError: null,
      };

    case TEMPLATE_FETCH_TEMPLATE_SUCCESS:
      return {
        ...state,
        fetchTemplatePending: false,
        fetchTemplateError: null,
        template: action.data,
      };

    case TEMPLATE_FETCH_TEMPLATE_FAILURE:
      return {
        ...state,
        fetchTemplatePending: false,
        fetchTemplateError: action.data.error,
      };

    case TEMPLATE_FETCH_TEMPLATE_DISMISS_ERROR:
      return {
        ...state,
        fetchTemplateError: null,
      };

    default:
      return state;
  }
}
